/* import __COLOCATED_TEMPLATE__ from './upfront-email-collection.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();